<div (click)="toggle()" class="wrapper group" [class.active]="value()">
    <div
        [attr.data-size]="size()"
        class="checkbox"
        [ngClass]="value() ? class() : 'bg-white border-gray-300'"
    >
        @if (value()) {
            <img
                [attr.data-size]="size()"
                class="icon"
                src="https://api.iconify.design/ic:baseline-check.svg?color=%23ffffff"
            />
        }
    </div>
    @if (label()) {
        <div
            class="flex flex-col gap-1 cursor-pointer"
            [class.active]="value()"
        >
            @if (label(); as label) {
                <p [attr.data-size]="size()" class="label theme-text">
                    {{ label }}
                </p>
            }
            @if (description(); as description) {
                <p [attr.data-size]="size()" class="text-gray-500 description">
                    {{ description }}
                </p>
            }
        </div>
    }
</div>
